import { twMerge } from "tailwind-merge"
import { BASE_PATH } from "@/constants/app.mjs"
import CaseStudyCard, { type CaseStudy } from "../appListing/CaseStudyCard"
import { caseStudyRowCss } from "../appListing/FeaturedCaseStudiesCss"

const caseStudies: CaseStudy[] = [
  {
    id: "aptos",
    tagline:
      "Onchain decision making for a high-performance chain focused on scalability, safety, and user experience",
    href: "https://tokenterminal.com/resources/articles/aptos-data-partnership",
    backgroundImage: `${BASE_PATH}/static/images/marketing/chain-partnership/case-study-background-aptos.svg`,
    logo: `${BASE_PATH}/static/images/marketing/chain-partnership/case-study-logo-aptos.svg`,
  },

  {
    id: "immutable",
    tagline:
      "Standardized metrics enabled for a chain that offers EVM compatibility, low cost, massive scale, and security. ",
    href: "https://tokenterminal.com/resources/articles/immutable-data-partnership",
    backgroundImage: `${BASE_PATH}/static/images/marketing/chain-partnership/case-study-background-immutable-zkevm.svg`,
    logo: `${BASE_PATH}/static/images/marketing/chain-partnership/case-study-logo-immutable.svg`,
  },

  {
    id: "ton",
    tagline:
      "Full data available for the chain platform originally developed by Telegram, designed for scalable, fast, and secure transactions,",
    href: "https://tokenterminal.com/resources/articles/ton-data-partnership",
    backgroundImage: `${BASE_PATH}/static/images/marketing/chain-partnership/case-study-background-ton.svg`,
    logo: `${BASE_PATH}/static/images/marketing/chain-partnership/case-study-logo-ton.svg`,
  },
  {
    id: "sonic",
    tagline:
      "Standardized metrics enabled for a high-performance EVM L1 with low fees and a growing app ecosystem.",
    href: "https://tokenterminal.com/resources/articles/sonic-is-live-on-token-terminal",
    backgroundImage: `${BASE_PATH}/static/images/marketing/chain-partnership/case-study-background-sonic.svg`,
    logo: `${BASE_PATH}/static/images/marketing/chain-partnership/case-study-logo-sonic.svg`,
  },
]

const FeaturedCaseStudies = () => {
  return (
    <div className="flex flex-col gap-6 items-center justify-center">
      <div className="text-sm text-fg-secondary">Case studies</div>
      <div className={twMerge("flex items-center gap-6", caseStudyRowCss)}>
        {caseStudies.map((caseStudy, _index) => (
          <CaseStudyCard caseStudy={caseStudy} key={caseStudy.id} />
        ))}
      </div>
    </div>
  )
}

export default FeaturedCaseStudies
